// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"012dd6d0","952":"b3ac1129"}[chunkId] + ".chunk.js";
};